import React, { useState, useCallback, useEffect } from 'react';
import { roles } from '../../Constants';
import useApi from '../../api/useApi';

function index({ showNotification, upDateAvatar, user }) {
  const orgId = JSON.parse(localStorage.user).organization.id;

  const formModel = {
    userName: user.userName,
    slug: user.slug,
    email: user.email,
    contact: user.contact,
    avatar: user.avatar,
    role: user.role,
    organizationId: orgId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, updateData] = useApi();

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  // useEffect(() => {
  //   if (!isLoading && !isError && data === '') {
  //     showNotification('success', 'User Details updated Successfully');
  //   }
  //   if (isError) {
  //     showNotification('error', 'Unable to update user details');
  //   }
  // }, [isLoading, isError, data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateData(`/user/${user.userId}`, 'PATCH', formData);
    upDateAvatar();
  };

  const getRole = (roleCode) => {
    const x = roles.filter((role) => role.id == roleCode);
    return x[0].value;
  };

  return (
    <div>
      <p className="mt-3 font-bold text-lg text-textBlue1">General Info</p>
      <form className="mt-3 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="userName" className="mb-1 block text-parameter text-sm">
            NAME
          </label>
          <input
            type="text"
            value={formData.userName}
            name="userName"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handleInputChange}
          />
        </div>

        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="slug" className="mb-1 block text-parameter text-sm">
            SHORT NAME
          </label>
          <input
            type="text"
            value={formData.slug}
            name="slug"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handleInputChange}
          />
        </div>

        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="email" className="mb-1 block text-parameter text-sm">
            EMAIL
          </label>
          <input
            type="email"
            value={formData.email}
            name="email"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handleInputChange}
          />
        </div>

        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="contact" className="mb-1 block text-parameter  text-sm">
            PHONE NUMBER
          </label>
          <input
            type="tel"
            value={formData.contact}
            name="contact"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handleInputChange}
          />
        </div>

        <div className=" w-1/3 items-center my-3.5">
          <label htmlFor="role" className="mb-1 block text-parameter  text-sm">
            ROLE
          </label>

          <input
            type="text"
            value={getRole(formData.role)}
            disabled
            name="role"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handleInputChange}
          />
        </div>

        <div className="flex w-full items-center justify-end mt-6 relative">
          {isLoading ? (
            <img src="assets/img/loader.svg" className="w-16 mr-6 ml-auto" alt="" />
          ) : (
            <input
              type="submit"
              value="Save Changes"
              className="rounded-lg focus:outline-none w-1/4 mr-8 h-10 text-textBlue1 cursor-pointer "
              style={{ background: '#16406D33', border: '1px solid #16406D' }}
            />
          )}
        </div>
      </form>
    </div>
  );
}

export default index;
